<script>
import swal from 'sweetalert';

export default{
    data: function () {
      return {
      }
    }
    , mounted: function () {
    }
    , methods: {
        fnOnClickSuccessAlert:function(questionInfoValue, questionTitle, questionContent, resultContent){
            let _preInfo = this.fnOnLoadSwalImageData(questionInfoValue);
            let _ansInfo = this.fnOnLoadSwalImageData(questionInfoValue);
            swal({
                 title: questionTitle,
                 text:  questionContent,
                 icon : _preInfo,
                 buttons : {
                    cancel: {
                        text    : "취소",
                        value   : false,
                        visible : false,
                    },
                    confirm: {
                        text    : "확인",
                        value   : true,
                        visible : true,
                    }
                },
                 dangerMode: true
            }).then(result => {
                if(result){
                    swal({
                        title: "",
                        text:  resultContent,
                        icon : _ansInfo
                        
                    })
                } 
                return true;
            });
        }
        , fnOnClickErrorAlert:function(questionInfoValue, questionTitle, questionContent){
            let _preInfo = this.fnOnLoadSwalImageData(questionInfoValue);
            let _ansInfo = this.fnOnLoadSwalImageData("error");

            swal({
                 title: questionTitle,
                 text:  questionContent,
                 icon : _preInfo,
                 buttons : {
                    cancel: {
                        text    : "취소",
                        value   : false,
                        visible : false,
                    },
                    confirm: {
                        text    : "확인",
                        value   : true,
                        visible : true,
                    }
                },
                 dangerMode:true,
            }).then(result => {
                if(result){
                   swal({
                        title: "",
                        text:  "확인을 부탁드립니다.",
                        icon : _ansInfo
                    })
                    return false;
                }
            });
        }
        , fnOnClickConfirmAlert:function(questionInfoValue, questionTitle, questionContent, resultContent){
            let _preInfo = this.fnOnLoadSwalImageData(questionInfoValue);
            let _ansInfo = this.fnOnLoadSwalImageData("info");

            swal({
                title   : questionTitle,
                text    : questionContent,
                icon    : _preInfo,
                buttons : {
                    cancel: {
                        text    : "취소",
                        value   : false,
                        visible : true,
                    },
                    confirm: {
                        text    : "확인",
                        value   : true,
                        visible : true,
                    }
                },
                dangerMode:true,
            }).then(result => {
                if(result){
                   swal({
                        title   : "",
                        text    : resultContent,
                        icon    : _ansInfo
                    })
                    return true;
                } else {
                    return false;
                }
            });
        }
         , fnOnLoadSwalImageData:function(value){
            let _icon = "http://localhost:8080/design/common/images/sub/img_alert_"+value+".png";
            return _icon;
         }
    }
  }
</script>